import { type ReactNode } from 'react';

import type { MatchStateClient } from '../../schema/sport/entry.js';
import { cn } from '../utils/entry.js';

type CouponEventMatchStatusProps = {
  matchStatusText: string;
  className?: string;
  matchResultState?: MatchStateClient;
};

/**
 * Component to render match status.
 *
 * @param root0 props for match status
 * @param root0.matchStatusText match status text to display
 * @param root0.className optional class name for styling
 * @param root0.matchResultState match result state to determine text color
 * @returns Component for MatchStatus
 */
export function CouponInitMatchStatus({
  matchStatusText,
  className,
  matchResultState,
}: CouponEventMatchStatusProps): ReactNode {
  return (
    <div className={cn(matchResultState === 'Live' ? 'text-tertiary-variant-fg' : 'text-layer-fg-muted', className)}>
      {matchStatusText}
    </div>
  );
}
